import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Page } from '../models/page.model';
import { ContainerFacility } from './models/container-facility.model';

@Injectable({
  providedIn: 'root'
})
export class ContainerFacilityService {
  private readonly baseUrl = `${environment.restApiUrl}container-tracking/facilities`;

  constructor(private http: HttpClient) {}

  create(payload: ContainerFacility): Observable<ContainerFacility> {
    return this.http.post<ContainerFacility>(this.baseUrl, payload);
  }

  findById(id: number): Observable<ContainerFacility> {
    return this.http.get<ContainerFacility>(`${this.baseUrl}/${id}`);
  }

  findAll(params: HttpParams): Observable<Page<ContainerFacility>> {
    return this.http.get<Page<ContainerFacility>>(this.baseUrl, { params });
  }

  update(id: number, payload: ContainerFacility): Observable<ContainerFacility> {
    return this.http.put<ContainerFacility>(`${this.baseUrl}/${id}`, payload);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }
}
